import chalk from "chalk";

chalk.level = 3;

const chalkInstance = {
  request: (...args: (string | undefined | null)[]) => {
    console.log(chalk.black.bgYellowBright.bold("【request】", ...args));
  },
  response: (...args: (string | undefined | null)[]) => {
    console.log(chalk.black.bgGreen.bold("【response】", ...args));
  },
  streamResponse: (...args: (string | undefined | null)[]) => {
    console.log(chalk.black.bgGreen.bold("【stream raw】", ...args));
  },
  traceLog: (...args: (string | undefined | null)[]) => {
    console.log(chalk.black.bgCyanBright.bold("【traceLog】", ...args));
  },
};

export default chalkInstance;
